import React from 'react'
import { Form, Button, InputNumber, Input, Tooltip, Icon } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }

    return (
      <Form onSubmit={this.handleOnSubmit} >
        <FormItem
          label={
            <React.Fragment>
              Сумма пополнения
              <Tooltip title='Валюта торговой сети'>
                <Icon
                  type='info-circle'
                  style={{ color: 'rgba(0,0,0,.45)', paddingLeft: 0, paddingTop: 5 }}
                />
              </Tooltip>
            </React.Fragment>}
          {...formItemLayout}
        >
          {getFieldDecorator('n_amount', {
            rules: [{ required: true, message: 'Пожалуйста введите сумму пополнения.' }],
          })(<InputNumber
            style={{ width: '100%' }}
            placeholder=''
            min={1}
            max={50000}
            step={1}
          />)}
        </FormItem>
        <FormItem label='Комментарий' {...formItemLayout}>
          {getFieldDecorator('s_comment', {
            rules: [{ required: true, message: 'Пожалуйста введите комментарий.' }],
          })(<TextArea rows={4} placeholder='Комментарий' />)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isAddItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            Пополнить
          </Button>
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    return {
      n_amount: Form.createFormField(formFieldValues.n_amount),
      s_comment: Form.createFormField(formFieldValues.s_comment),
    }
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/SellerForm/BalanceForm.jsx